import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import { MessageSquare } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const POLL_MS = 30000;

/**
 * Polls /api/conversations/unread/count every 30s.
 * Renders a small icon button with a gold badge if unread > 0.
 * Used in the global navbar.
 */
export const UnreadMessagesBadge = ({ className = '' }) => {
  const { token, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    if (!isAuthenticated || !token) return;
    let cancelled = false;
    const poll = async () => {
      try {
        const r = await axios.get(`${API}/conversations/unread/count`, { headers: { Authorization: `Bearer ${token}` } });
        if (!cancelled) setUnread(r.data?.unread || 0);
      } catch (_) { /* silent */ }
    };
    poll();
    const id = setInterval(poll, POLL_MS);
    return () => { cancelled = true; clearInterval(id); };
  }, [isAuthenticated, token]);

  if (!isAuthenticated) return null;

  return (
    <button
      type="button"
      onClick={() => navigate('/messages')}
      className={`relative p-2 hover:bg-[#0F4C5C]/5 rounded-full transition-colors ${className}`}
      aria-label={`Messages${unread > 0 ? ` (${unread} unread)` : ''}`}
      data-testid="messages-badge-btn"
    >
      <MessageSquare className="w-5 h-5 text-[#0F4C5C]" />
      {unread > 0 && (
        <span
          className="absolute -top-0.5 -right-0.5 bg-[#E9C46A] text-[#0F4C5C] text-[10px] font-bold rounded-full min-w-[18px] h-4.5 px-1.5 flex items-center justify-center shadow-sm"
          data-testid="messages-unread-count"
        >
          {unread > 99 ? '99+' : unread}
        </span>
      )}
    </button>
  );
};
